<script>
  import ProductListItem from '@/components/ProductListItem.vue';
  import { whenFastSimonReady } from '@/lib/vue-helpers.js';
  import { emitter } from '@/main.js';

  export default {
    components: {
      ProductListItem
    },
    data() {
      return {
        productsOnDisplay: [],
        collectionId: '',
        limit: 0,
        productImageName: '',
        showCrosssellPercentage: 'false',
        placeholderId: '',
        loadedProducts: new Set(),
        hasLoadedProducts: false
      };
    },
    mounted() {
      this.collectionId = this.$el.parentElement.getAttribute('data-collection-id');
      const limitAttr = this.$el.parentElement.getAttribute('data-limit');
      this.limit = limitAttr ? parseInt(limitAttr) : 4;
      this.productImageName = this.$el.parentElement.getAttribute('data-product_swatch_name');
      this.showCrosssellPercentage = this.$el.parentElement.getAttribute('data-show-crosssell-percentage') || 'false';
      this.placeholderId = this.$el.parentElement.getAttribute('data-placeholder-id') || '';
      this.getProductData();

      emitter.on('product-slide-loaded', this.handleProductLoaded);
    },
    unmounted() {
      emitter.off('product-slide-loaded', this.handleProductLoaded);
      this.loadedProducts.clear();
    },
    computed: {
      wrapClass() {
        return 'collection-split__product grid__item';
      },
      limitedProducts() {
        return this.productsOnDisplay.slice(0, this.limit);
      }
    },
    watch: {
      loadedProducts: {
        handler() {
          this.checkAndRemovePlaceholder();
        },
        deep: true
      },
      limitedProducts: {
        handler() {
          // Reset loaded products when products change
          this.loadedProducts.clear();
          this.hasLoadedProducts = false;
        },
        immediate: false
      }
    },
    methods: {
      getProductData() {
        whenFastSimonReady(() => {
          window.FastSimonSDK.smartCollections({
            categoryID: this.collectionId,
            callback: response => {
              const prods = response.payload.products;
              const dataModified = [];
              if (prods.length > 0) {
                dataModified.push(...prods.filter(item => !item.promotile));
              }
              this.productsOnDisplay = dataModified;
            }
          });
        });
      },
      handleProductLoaded(index) {
        this.loadedProducts.add(index);
      },
      checkAndRemovePlaceholder() {
        if (this.placeholderId && this.limitedProducts.length > 0) {
          // Only remove placeholder when all products have loaded
          if (this.loadedProducts.size === this.limitedProducts.length) {
            // Show all products at once
            this.hasLoadedProducts = true;
            this.$nextTick(() => {
              setTimeout(() => {
                const placeholderContainer = document.getElementById(this.placeholderId);
                if (placeholderContainer) {
                  placeholderContainer.remove();
                }
              }, 300);
            });
          }
        }
      }
    }
  };
</script>

<template>
  <div v-for="(product, index) in limitedProducts" :key="product.id" :class="[wrapClass, { 'is-hidden': !hasLoadedProducts }]" data-item>
    <ProductListItem :hideSwatches="true" :productImageName="productImageName" :key="'grid' + product.l + '-' + index" :pid="product.id" :productTitle="product.l" :disableSlider="true" :slideIndex="index" v-if="product.l" :showSalePercentage="showCrosssellPercentage === 'true'"> </ProductListItem>
  </div>
</template>

<style lang="scss">
  .fs-collection-split {
    // .fs-collection-split .carousel
    .carousel {
      touch-action: auto;
    }

    // Hide products until all are loaded
    .collection-split__product.is-hidden {
      opacity: 0;
    }

    .collection-split__product {
      transition: opacity 0.3s ease;
    }
  }
</style>
